import { keyApp, useStore } from "hooks/useStore";
import UserDto from "types/UserDto";

interface StoreValues {
  handleAppChange: (key: keyof StoreValues, value: unknown) => void;
  canNavigate: boolean;
  currentUser: UserDto;
}

export default function useAppStore() {
  const { handleAppChange, ...rest } = useStore(
    (store) => store[keyApp],
  ) as StoreValues;

  function setCanNavigate(canNavigate: boolean) {
    handleAppChange("canNavigate", canNavigate);
  }

  return { handleAppChange, setCanNavigate, ...rest };
}
